import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '@/App';
import reportWebVitals from './reportWebVitals';
import GlobalStyles from '@/components/GlobalStyles';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '@/app/store';
import SpinLoading from '@/components/SpinLoading';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GlobalStyles>
            <Provider store={store}>
                <PersistGate loading={<SpinLoading />} persistor={persistor}>
                    <App />
                </PersistGate>
            </Provider>
        </GlobalStyles>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
